import {createAction, props} from '@ngrx/store';
import {ActionDialog} from '@core/redux/action-dialog';

export const openDialog = createAction(
  '[App] openDialog',
  props<{ dialog: ActionDialog }>()
);
export const closeDialog = createAction(
  '[App] close dialog'
);
export const navigateTo = createAction(
  '[App] navigate to',
  props<{ path: string }>()
);
